import React from "react";
import AskExpert from "./ask-expert/ask-expert";
import Footer from "pages/landing-page/items/footer/footer";
import s from "./contacts.module.scss";

const ContactsPage = (props) => {


    return (
            <div className={s.Contacts}>
                <div className={s.sendQuestion}>
                    <AskExpert 
                                getValue={props.getValue} 
                                setMenuActive={props.setMenuActive} 
                                sendMessage={props.sendMessage} 
                                isDemoSuccess={props.isDemoSuccess} 
                                setIsDemoSuccess={props.setIsDemoSuccess}
                                selectedLanguage={props.selectedLanguage}
                    />
                </div>
                
                <Footer getValue={props.getValue} setMenuActive={props.setMenuActive}/>
            </div>
    )
}

export default ContactsPage;